import React, { useEffect, useState } from 'react';
import { message, Space } from 'antd';
import { LoadingOutlined, ExportOutlined } from '@ant-design/icons';
import html2canvas from 'html2canvas';


interface ExportPostComponentProps {
  postUrl: string;
  componentName: string;
  selector: string;
  format: string;
  exportComponent: boolean;
  setExportPostComponent: (state: boolean) => void;
  postId: string;
}

const ExportPostComponent = (props: ExportPostComponentProps) => {
  const { componentName, selector, format, setExportPostComponent, exportComponent } = props;
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (exportComponent === true) {
      handleExport();
    }
  }, [exportComponent]);

  const handleExport = async () => {
    try {
      setIsLoading(true);
      const element = document.querySelector(selector) as HTMLElement;
      
      if (!element) {
        throw new Error('Element not found');
      }

      // Find and hide export buttons
      const exportButtons = element.querySelectorAll('.btn-export-options');
      const originalDisplayValues: string[] = [];
      
      // Store original display values and hide buttons
      exportButtons.forEach((button) => {
        originalDisplayValues.push((button as HTMLElement).style.display);
        (button as HTMLElement).style.display = 'none';
      });

      const canvas = await html2canvas(element, {
        useCORS: true, // Enable CORS for images
        logging: false,
      });

      // Restore original display values
      exportButtons.forEach((button, index) => {
        (button as HTMLElement).style.display = originalDisplayValues[index];
      });

      // Convert canvas to blob
      canvas.toBlob((blob: Blob | null) => {
        if (!blob) {
          throw new Error('Failed to create blob');
        }

        // Create download link
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${componentName?.split(' ').join('')}.${format}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        message.success('Export completed successfully');
      }, `image/${format}`);

    } catch (error) {
      console.error('Export error:', error);
      message.error('Error exporting component, please try again');
    } finally {
      setIsLoading(false);
      setExportPostComponent(false);
    }
  };

  return (
    <>
      <Space
        onClick={(e) => {
          setExportPostComponent(true);
          e.stopPropagation();
        }}
      >
        {isLoading ? <LoadingOutlined /> : <ExportOutlined />}
        {isLoading ? 'Preparing export...' : `Export ${format}`}
      </Space>
    </>
  );
};

export { ExportPostComponent };
